import { IpAccessRules } from "../modules";

export const IpAccessRulesPage = () => {
  return <IpAccessRules />;
};
